export default __webpack_public_path__ + "6b45659aa10252f0b1da4da9597057e6.svg";